export default class HoverGauge extends Phaser.Group {
  constructor(game, x, y) {
    super(game);

    this.x = x;
    this.y = y;

    this.asset = this.game.make.spine(0, 0, 'spine_hover', true);
    this.asset.anchor.set(0.5, 1);
    this.addChild(this.asset);
    this.anim = this.asset.setAnimationByName(0, 'animation', false);
    //
    this.rootBone = this.asset.skeleton.getRootBone();
    this.rootBone.scaleX = 0.8;
    this.rootBone.scaleY = 0.8;
  }

  show() {
    if (this.tween) {
      this.tween.onComplete.remove(this.handleHide, this);
      this.tween.stop();
    }

    this.visible = true;
    this.alpha = 1;
    this.anim = this.asset.setAnimationByName(0, 'animation', false);
  }

  hide() {
    if (this.tween) {
      this.tween.stop();
    }
    this.tween = this.game.add.tween(this).to({ alpha: 0 }, 150, Phaser.Easing.Quadratic.Out, true);
    this.tween.onComplete.addOnce(this.handleHide, this);
  }

  handleHide() {
    this.visible = false;
  }

  setValue(value) {
    value;
  }
}
